<template>
    <div id="system-configuration-registered-at">
        <v-overlay absolute="" opacity="0.2" :value="loader">
            <v-progress-circular :color="appColor" indeterminate size="32"></v-progress-circular>
        </v-overlay>
        <v-snackbar v-model="snackbar.status" top :color="snackbar.color" :timeout="snackbar.timeout">
            <v-icon class="mr-1">{{ snackbar.icon }}</v-icon> {{ snackbar.message }}
        </v-snackbar>
        <system-configuration-registered-at-toolbar></system-configuration-registered-at-toolbar>
        <v-container fluid>
            <v-row>
                <v-col cols="12">
                    <system-configuration-registered-at-manager :data="data" :permission="permission"
                        @refreshData="refreshData" @setNotification="setNotification">
                    </system-configuration-registered-at-manager>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import auth from '../../../js/auth';
import SystemConfigurationRegisteredAtManager from '../../../components/Admin/SystemConfiguration/RegisteredAt/Manager';
import SystemConfigurationRegisteredAtToolbar from '../../../components/Admin/SystemConfiguration/RegisteredAt/Toolbar';

export default {
    name: 'system-configuration-registered-at',
    components: {
        SystemConfigurationRegisteredAtManager,
        SystemConfigurationRegisteredAtToolbar
    },
    data() {
        return {
            data: [],
            loader: true,
            permission: {},
            refreshTimer: '',
            snackbar: {
                color: 'success',
                icon: '',
                message: '',
                status: false,
                timeout: 5000
            }
        }
    },
    methods: {
        getRegisteredAtData() {
            const that = this;
            let api =
                `https://${location.hostname}/cgi-bin/res-app-api/controller.api.pl?getEntity&type=RegisteredAt`;

            // GET request
            fetch(api)
                .then(function (response) {
                    // Return response
                    return response.json();
                })
                .then(function (json) {
                    // Error handling
                    if (json.message.match(/UNAUTHORIZED/i)) {
                        that.setNotification('#f64e60', 'mdi-alert-outline', `You are not authorized to view this resource. Please refresh your application.`, true);
                    } else if (!json.result.match(/OK/i)) {
                        that.setNotification('#ffb822', 'mdi-alert-circle', `System configuration registered at data could not be retrieved. Please contact your system administrator.`, true);
                    }

                    that.data = json.data;
                    that.setLoader(false);
                })
                .catch(function () {
                    that.setLoader(false);
                })
        },
        getPermission() {
            this.permission = auth.getPermission("adminsystemconfiguration");
        },
        refreshData() {
            this.getRegisteredAtData();
        },
        setLoader(bool) {
            this.loader = bool;
        },
        setNotification(color, icon, message, status) {
            // Reset snackbar
            this.snackbar.status = false;

            // Set snackbar fields
            this.snackbar.color = color;
            this.snackbar.icon = icon;
            this.snackbar.message = message;
            this.snackbar.status = status;
        }
    },
    computed: {
        appColor() {
            return '#191b2a';
        }
    },
    created() {
        this.refreshData();
        this.getPermission();
        this.refreshTimer = setInterval(this.refreshData, 60000);
    },
    beforeDestroy() {
        // Clear refresh function
        clearInterval(this.refreshTimer);
    },
    destroyed() {
        // Clear refresh function
        clearInterval(this.refreshTimer);
    }
}
</script>